import React, { Component } from "react";
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  Modal,
} from "react-bootstrap";

import RenderYearTab from "../../../Components/shared/RenderYearTab";
import RootLayout from "../../../Components/shared/RootLayout";
import CONSTANTS from "../../../Phi/Constants";
import Phi from "../../../Phi/Phi";
import downarrow from "../../DashboardContainer/Component/NewUiimg/downarrowstudent.png";
import search from "../../DashboardContainer/Component/NewUiimg/search.png";
import upar from "../../DashboardContainer/Component/NewUiimg/upar.png";
import history from "./../../../history";
import HSGStudentGrid from "./HSGStudentGrid/HSGStudentGrid";
import "./Student.css";
import Filter from "../../../Components/shared/Filter";

class Student extends Component {
  constructor(props) {
    super(props);
    const savedState = JSON.parse(
      sessionStorage.getItem("studentListState") || "{}",
    );

    this.state = {
      studentArr: [],
      showConfirmationModal: false,
      selectedClass: savedState.selectedClass || null,
      selectedSection: savedState.selectedSection || null,
      selectedStatus: savedState.selectedStatus || null,
      inSearchString: savedState.inSearchString || "",
      selectedStudentType: null,
      seletedTab: null,
      dropdownOpen: false,
      activeDropdown: null,

      options: {
        toolBar: (props) => this.toolbar(props),
        searchPanel: (props) => this.searchPanel(props),
      },
    };

    this.dropdownRef = React.createRef();
    this.classDropdownRef = React.createRef();
    this.sectionDropdownRef = React.createRef();
    this.statusDropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  persistStudentListState = () => {
    const payload = {
      inOffset: this.props.studentHeader?.inOffset || 0,
      inSearchString:
        this.state.inSearchString ||
        this.props.studentHeader?.inSearchString ||
        "",
      class: this.props.studentHeader?.class || this.state.selectedClass || "",
      section:
        this.props.studentHeader?.section || this.state.selectedSection || "",
      isAssessed:
        this.props.studentHeader?.isAssessed !== undefined
          ? this.props.studentHeader.isAssessed
          : (this.state.selectedStatus ?? null),
      selectedClass: this.state.selectedClass ?? null,
      selectedSection: this.state.selectedSection ?? null,
      selectedStatus: this.state.selectedStatus ?? null,
    };

    sessionStorage.setItem("studentListState", JSON.stringify(payload));
  };

  componentWillUnmount() {
    this.persistStudentListState();
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target) &&
      this.state.dropdownOpen
    ) {
      this.setState({ dropdownOpen: false });
    }

    if (this.state.activeDropdown) {
      const activeRefMap = {
        class: this.classDropdownRef,
        section: this.sectionDropdownRef,
        status: this.statusDropdownRef,
      };

      const currentRef = activeRefMap[this.state.activeDropdown];
      if (
        currentRef &&
        currentRef.current &&
        !currentRef.current.contains(event.target)
      ) {
        this.setState({ activeDropdown: null });
      }
    }
  };

  toggleDropdown = (name) => {
    this.setState((prevState) => ({
      activeDropdown: prevState.activeDropdown === name ? null : name,
    }));
  };

  componentWillMount() {
    const savedState = JSON.parse(
      sessionStorage.getItem("studentListState") || "{}",
    );

    const savedOffset = savedState.inOffset || 0;
    const savedSearch = savedState.inSearchString || "";
    const savedClass = savedState.class || "";
    const savedSection = savedState.section || "";
    const savedStatus = savedState.isAssessed || null;
    let organization = JSON.parse(Phi.Storage.getItem("organization"));

    if (organization) {
      if (
        this.props.currentProgram &&
        Object.keys(this.props.currentProgram).length > 0
      ) {
        sessionStorage.setItem(
          "selectedBillingId",
          String(this.props.currentProgram.billing?.id || ""),
        );

        let startNode = this.props.currentProgram.billing
          ? this.props.startNodeMap[this.props.currentProgram.billing.id]
          : null;
        if (startNode) {
          this.props.fetchStudentList(
            Object.assign({}, this.props.studentHeader, {
              startNode: startNode.id,
              inOffset: savedOffset,
              inSearchString: savedSearch,
              inLimit: 6,
              class: savedClass,
              section: savedSection,
              isAssessed: savedStatus,
            }),
          );
        }
      } else {
        this.props.getProgramByOrganization(organization[0].org_id);
      }

      this.props.getStudentBoardingType(organization[0].org_id);
    }
  }

  componentWillReceiveProps(newProps) {
    if (
      JSON.stringify(newProps.currentProgram) !==
        JSON.stringify(this.props.currentProgram) &&
      newProps.currentProgram.billing
    ) {
      let startNode =
        newProps.startNodeMap[newProps.currentProgram?.billing?.id];
      this.props.fetchStudentList(
        Object.assign({}, this.props.studentHeader, {
          startNode: startNode.id,
          inLimit: 6,
        }),
      );
    }
  }

  customMultiSelect = (props) => {
    const { type, checked, disabled, onChange, rowIndex } = props;
    return (
      <div className="hsg-checkbox-sm">
        <input
          type={type}
          name={"checkbox" + rowIndex}
          id={"checkbox" + rowIndex}
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e, rowIndex)}
          ref={(input) => {
            if (input) {
              input.indeterminate = props.indeterminate;
            }
          }}
        />
        <label htmlFor={"checkbox" + rowIndex}>
          <div className="check"></div>
        </label>
      </div>
    );
  };

  downloadStudentReport = (studentId) => {
    this.props.setLoader();
    let startNode =
      this.props.startNodeMap[this.props.currentProgram.billing.id];
    this.props.getStudentReport("health_card", {
      startNodeId: startNode.id,
      studentId,
      type: "pdf",
    });
  };

  downloadBulkStudentReport = () => {
    let startNode =
      this.props.startNodeMap[this.props.currentProgram.billing.id];
    this.props.getBulkStudentReport("all", {
      startNodeId: startNode.id,
      studentArr: this.state.studentArr,
      type: "pdf",
    });
  };

  downloadBulkCBSEStudentReport = () => {
    let startNode =
      this.props.startNodeMap[this.props.currentProgram.billing.id];
    this.props.getBulkStudentReport("health_card", {
      startNodeId: startNode.id,
      studentArr: this.state.studentArr,
      type: "pdf",
    });
  };

  downloadAllStudentReport = () => {
    this.switchConfirmationModal(false);
    this.props.setLoader();
    let startNode =
      this.props.startNodeMap[this.props.currentProgram.billing.id];
    this.props.getBulkStudentReport("all", {
      startNodeId: startNode.id,
      studentArr: this.state.studentArr,
      type: "pdf",
    });
  };

  downloadAllCBSEStudentReport = () => {
    this.props.setLoader();
    let startNode =
      this.props.startNodeMap[this.props.currentProgram.billing.id];
    this.props.getBulkStudentReport("health_card", {
      startNodeId: startNode.id,
      studentArr: this.state.studentArr,
      type: "pdf",
    });
  };

  handleSelectAll = (isSelected, rows = []) => {
    let studentArr = !!isSelected
      ? rows
          .filter((row) => row.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED)
          .map((row) => row.uuid)
      : [];
    this.setState({ studentArr });
  };

  onRowSelect = (row, isSelected) => {
    let studentArr = this.state.studentArr.slice();
    if (!!isSelected && row.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED) {
      studentArr.push(row.uuid);
    } else {
      let idx = studentArr.indexOf(row.uuid);
      if (idx > -1) {
        studentArr.splice(idx, 1);
      }
    }
    this.setState({ studentArr });
  };

  showNext = (where) => {
    let { inLimit, inOffset } = this.props.studentHeader;
    let { totalStudent, studentHeader } = this.props;
    if (where === "prev") {
      let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit;
      this.props.fetchStudentList(
        Object.assign({}, studentHeader, { inOffset: newOffset }),
      );
    } else {
      if (inOffset >= totalStudent || inOffset + inLimit >= totalStudent) {
        return;
      }
      let newOffset = inOffset + inLimit;
      this.props.fetchStudentList(
        Object.assign({}, studentHeader, { inOffset: newOffset }),
      );
    }
  };

  viewReport = () => {
    history.push("/student-list");
  };

  switchConfirmationModal = (val) =>
    this.setState({ showConfirmationModal: Boolean(val) });

  confirmationModal = () => (
    <Modal
      show={this.state.showConfirmationModal}
      onHide={() => this.switchConfirmationModal(false)}
    >
      <Modal.Header>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to download all reports? This might take
          sometime!
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="hsg-btn-white"
          onClick={() => this.switchConfirmationModal(false)}
        >
          Close
        </button>
        <button
          className="hsg-btn yes-btn"
          onClick={() => this.downloadAllStudentReport()}
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );

  fetchNewFilteredList = (newFilter) => {
    let startNode = this.props.currentProgram.billing
      ? this.props.startNodeMap[this.props.currentProgram.billing.id]
      : null;
    const {
      selectedClass,
      selectedSection,
      selectedStatus,
      inSearchString,
      selectedType,
    } = this.state;

    if (newFilter) {
      startNode &&
        this.props.fetchStudentList(
          Object.assign({}, this.props.studentHeader, {
            startNode: startNode.id,
            inOffset: 0,
            inSearchString: inSearchString || "",
            class: selectedClass,
            section: selectedSection,
            isAssessed: selectedStatus,
            inStudentType: selectedType,
          }),
        );
    } else {
      startNode &&
        this.props.fetchStudentList(
          Object.assign({}, this.props.studentHeader, {
            startNode: startNode.id,
            inOffset: 0,
            inSearchString: "",
            class: null,
            section: null,
            isAssessed: null,
            inStudentType: null,
          }),
        );
    }
  };

  addNewFilter = (val, field) => {
    const updateState = {
      [field]: val,
      activeDropdown: null,
    };
    if (field === "selectedClass") {
      updateState.selectedSection = null;
    }
    this.setState(updateState, () => this.fetchNewFilteredList(true));
  };

  resetFilter = () => {
    this.setState(
      {
        selectedClass: null,
        selectedSection: null,
        selectedStatus: null,
        selectedType: null,
        inSearchString: "",
        activeDropdown: null,
      },
      () => this.fetchNewFilteredList(false),
    );
  };

  toolbar = () => {
    return (
      <div
        style={{
          display: "inline-block",
          alignItems: "center",
          justifyContent: "flex-start",
          borderBottom: "2px solid #1E87F0",
          marginLeft: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
            padding: "5px 10px 0px 0px",
            maxWidth: "350px",
            width: "100%",
          }}
        >
          <input
            onChange={(e) => this.changeSearchString(e)}
            onKeyDown={(e) => this.searchStudent(e)}
            placeholder="Type in student name or HSG-ID.."
            type="text"
            value={this.state.inSearchString}
            style={{
              flexGrow: 1,
              border: "none",
              outline: "none",
              padding: "5px 0px",
              marginRight: "10px",
              backgroundColor: "white",
              width: "250px",
            }}
          />
          <img
            className="seachiconV2"
            src={search}
            alt="Search Icon"
            style={{
              height: "20px",
              width: "20px",
              cursor: "pointer",
            }}
          />
        </div>
      </div>
    );
  };

  sortClassKeys = (classesObj = {}) => {
    const customOrder = [
      "PLAYGROUP",
      "PRE-NURSERY",
      "NURSERY",
      "LKG",
      "UKG",
      "KG",
      "PREP",
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
      "X",
      "XI",
      "XII",
    ];

    return Object.keys(classesObj).sort((a, b) => {
      const cleanA = a.toString().trim().toUpperCase();
      const cleanB = b.toString().trim().toUpperCase();
      const indexA = customOrder.indexOf(cleanA);
      const indexB = customOrder.indexOf(cleanB);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;

      return cleanA.localeCompare(cleanB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    });
  };

  getClasses = (classes = {}, selectedClass, isSmall) => {
    const isClassOpen = this.state.activeDropdown === "class";
    const isSectionOpen = this.state.activeDropdown === "section";
    const availableClasses = this.sortClassKeys(classes).filter(
      (c) => c !== this.state.selectedClass,
    );
    const availableSections =
      selectedClass && classes[selectedClass]
        ? classes[selectedClass].filter((s) => s !== this.state.selectedSection)
        : [];

    return !isSmall ? (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "nowrap",
          gap: "14px",
          flexShrink: 0,
        }}
      >
        <button
          // disabled={this.props.studentList?.length === 0}
          key={"reset"}
          style={{
            border: "none",
            color: "#9B9B9B",
            background: "transparent",
            cursor: "pointer",
            whiteSpace: "nowrap",
            fontSize: "14px",
            fontWeight: 500,
            padding: "4px 8px",
          }}
          onClick={() => this.resetFilter()}
        >
          RESET
        </button>

        <div
          ref={this.classDropdownRef}
          style={{
            position: "relative",
            display: "inline-block",
            flexShrink: 0,
          }}
        >
          <button
            disabled={this.props.studentList?.length === 0}
            type="button"
            onClick={() => this.toggleDropdown("class")}
            style={{
              background: "transparent",
              color: "#1E87F0",
              cursor: "pointer",
              border: "none",
              outline: "none",
              fontSize: "14px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 0",
              minWidth: "90px",
            }}
          >
            <span
              style={{
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {this.state.selectedClass || "CLASS"}
            </span>
            <img
              src={upar}
              style={{
                height: "16px",
                width: "16px",
                marginLeft: "8px",
                transform: isClassOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
              alt="Arrow"
            />
          </button>

          {isClassOpen && (
            <ul
              style={{
                position: "absolute",
                top: "calc(100% + 4px)",
                left: 0,
                backgroundColor: "#ffffff",
                zIndex: 1100,
                minWidth: "150px",
                maxHeight: "260px",
                overflowY: "auto",
                padding: "6px 0",
                margin: 0,
                listStyle: "none",
                borderRadius: "4px",
                border: "1px solid #E0E0E0",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
              }}
            >
              {availableClasses.map((eachClass) => (
                <li key={eachClass} style={{ margin: 0, padding: 0 }}>
                  <button
                    type="button"
                    onClick={() =>
                      this.addNewFilter(eachClass, "selectedClass")
                    }
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      textAlign: "left",
                      padding: "8px 16px",
                      fontSize: "13px",
                      background: "none",
                      border: "none",
                      display: "block",
                      color: "#333333",
                      outline: "none",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#F5F9FF")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    {eachClass}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div
          ref={this.sectionDropdownRef}
          style={{
            position: "relative",
            display: "inline-block",
            flexShrink: 0,
          }}
        >
          <button
            disabled={this.props.studentList?.length === 0}
            type="button"
            onClick={() => this.toggleDropdown("section")}
            style={{
              background: "transparent",
              color: "#1E87F0",
              cursor: "pointer",
              border: "none",
              outline: "none",
              fontSize: "14px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 0",
              minWidth: "90px",
            }}
          >
            <span
              style={{
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {this.state.selectedSection || "SECTION"}
            </span>
            <img
              src={upar}
              style={{
                height: "16px",
                width: "16px",
                marginLeft: "8px",
                transform: isSectionOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
              alt="Arrow"
            />
          </button>

          {isSectionOpen && (
            <ul
              style={{
                position: "absolute",
                top: "calc(100% + 4px)",
                left: 0,
                backgroundColor: "#ffffff",
                zIndex: 1100,
                minWidth: "140px",
                maxHeight: "260px",
                overflowY: "auto",
                padding: "6px 0",
                margin: 0,
                listStyle: "none",
                borderRadius: "4px",
                border: "1px solid #E0E0E0",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
              }}
            >
              {selectedClass && availableSections.length ? (
                availableSections.map((section) => (
                  <li key={section} style={{ margin: 0, padding: 0 }}>
                    <button
                      type="button"
                      onClick={() =>
                        this.addNewFilter(section, "selectedSection")
                      }
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        textAlign: "left",
                        padding: "8px 16px",
                        fontSize: "13px",
                        background: "none",
                        border: "none",
                        display: "block",
                        color: "#333333",
                        outline: "none",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#F5F9FF")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "transparent")
                      }
                    >
                      {section}
                    </button>
                  </li>
                ))
              ) : (
                <li
                  style={{
                    padding: "8px 16px",
                    fontSize: "13px",
                    color: "#999999",
                  }}
                >
                  {selectedClass ? "No other sections" : "Select class first"}
                </li>
              )}
            </ul>
          )}
        </div>
      </div>
    ) : (
      <ButtonGroup className="hsg-toolbar">
        <DropdownButton
          title={this.state.selectedClass || "Class"}
          id="dropdown-for-class"
          onSelect={(data) => this.addNewFilter(data, "selectedClass")}
        >
          {this.sortClassKeys(classes).map((eachClass) => (
            <MenuItem
              key={eachClass}
              eventKey={eachClass}
              active={this.state.selectedClass === eachClass}
            >
              {eachClass}
            </MenuItem>
          ))}
        </DropdownButton>
        <DropdownButton
          title={this.state.selectedSection || "Section"}
          id="dropdown-for-section"
          onSelect={(data) => this.addNewFilter(data, "selectedSection")}
        >
          {selectedClass && classes[selectedClass] ? (
            classes[selectedClass].map((section) => (
              <MenuItem
                key={section}
                eventKey={section}
                active={this.state.selectedSection === section}
              >
                {section}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>Please select a class</MenuItem>
          )}
        </DropdownButton>
        <Button
          bsStyle="btn hsg-btn-warning-small left"
          onClick={() => this.resetFilter()}
        >
          RESET
        </Button>
      </ButtonGroup>
    );
  };

  tab = () => {
    return <div>{this.toolbar()}</div>;
  };

  openNewTab = (hsgId, type) =>
    window.open(
      `/report/student/${
        this.props.startNodeMap[this.props.currentProgram.billing.id].id
      }/${type}/${hsgId}`,
      "_blank",
    );

  search(param) {
    let studentHeader = Object.assign({}, this.props.studentHeader);
    studentHeader.inSearchString = param;
    studentHeader.inOffset = 0;
    this.props.fetchStudentList(studentHeader);
  }

  searchStudent = (e) => {
    const { inSearchString } = this.state;
    e.keyCode === 13 && this.search(inSearchString.trim().toLowerCase());
  };

  changeSearchString = (e) => {
    this.setState({ inSearchString: e.target.value });
  };

  getAssessmentFilters = () => {
    const isStatusOpen = this.state.activeDropdown === "status";
    const statusOptions = [
      { label: "Assessed", key: true },
      { label: "Not Assessed", key: false },
    ];
    const availableStatuses = statusOptions.filter(
      (opt) => opt.key !== this.state.selectedStatus,
    );

    return (
      <div
        ref={this.statusDropdownRef}
        style={{ position: "relative", display: "inline-block", flexShrink: 0 }}
      >
        <button
          disabled={this.props.studentList?.length === 0}
          type="button"
          onClick={() => this.toggleDropdown("status")}
          style={{
            background: "transparent",
            color: "#1E87F0",
            cursor: "pointer",
            border: "none",
            outline: "none",
            fontSize: "14px",
            fontWeight: 500,
            whiteSpace: "nowrap",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "4px 0",
            minWidth: "90px",
          }}
        >
          <span>
            {this.state.selectedStatus === null
              ? "STATUS"
              : this.state.selectedStatus
                ? "Assessed"
                : "Not Assessed"}
          </span>
          <img
            src={upar}
            style={{
              height: "16px",
              width: "16px",
              marginLeft: "8px",
              transform: isStatusOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
            alt="Arrow"
          />
        </button>

        {isStatusOpen && (
          <ul
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              backgroundColor: "#ffffff",
              zIndex: 1100,
              minWidth: "140px",
              padding: "6px 0",
              margin: 0,
              listStyle: "none",
              borderRadius: "4px",
              border: "1px solid #E0E0E0",
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
            }}
          >
            {availableStatuses.map((item) => (
              <li key={String(item.key)} style={{ margin: 0, padding: 0 }}>
                <button
                  type="button"
                  onClick={() => this.addNewFilter(item.key, "selectedStatus")}
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    textAlign: "left",
                    padding: "8px 16px",
                    fontSize: "13px",
                    background: "none",
                    border: "none",
                    display: "block",
                    color: "#333333",
                    outline: "none",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#F5F9FF")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  changeTab = (nav, type) => {
    let startNode = this.props.startNodeMap[nav];
    const selectedProgram = this.props.programs?.find(
      (program) => program.billing && program.billing.id === nav,
    );

    this.setState({ seletedTab: nav });

    const activeTabMap = {
      year: () => {
        this.props.changeReportInReducer(nav);
        sessionStorage.setItem("selectedBillingId", String(nav));

        if (selectedProgram) {
          sessionStorage.setItem(
            "currentProgam",
            JSON.stringify(selectedProgram),
          );
        }

        this.props.fetchStudentList(
          Object.assign({}, this.props.studentHeader, {
            startNode: startNode.id,
            inOffset: 0,
            inSearchString: "",
          }),
        );
      },
    };

    activeTabMap[type]();
  };

  getStudentTypeFilter = () => {
    const type = this.state.selectedType;
    let status = this.props.boardingTypes;

    return status && status.length ? (
      <div className="right" key={"studentType"}>
        <DropdownButton
          title={type || "Type"}
          id="dropdown-for-student-type"
          onSelect={(data) => this.addNewFilter(data, "selectedType")}
        >
          {status.map((section) =>
            type === section.types ? (
              <MenuItem key={section.types} eventKey={section.types} active>
                {section.types}
              </MenuItem>
            ) : (
              <MenuItem key={section.types} eventKey={section.types}>
                {section.types}
              </MenuItem>
            ),
          )}
        </DropdownButton>
      </div>
    ) : null;
  };

  handleDownloadReport = (studentArr) => {
    studentArr.length
      ? this.downloadBulkStudentReport()
      : this.switchConfirmationModal(true);
  };

  handleCBSEDownloadReport = (studentArr) => {
    studentArr.length
      ? this.downloadBulkCBSEStudentReport()
      : this.downloadAllCBSEStudentReport();
  };

  getToolbarItems = () => {
    return window.innerWidth > 767 ? (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "nowrap",
          gap: "16px",
          flexShrink: 0,
        }}
      >
        {this.getClasses(this.props.classes, this.state.selectedClass)}
        {this.getAssessmentFilters()}
      </div>
    ) : (
      <ButtonToolbar className="hsg-toolbar">
        <ButtonGroup>
          <Button
            bsStyle="btn hsg-btn-warning-small"
            onClick={() =>
              this.handleDownloadReport(
                this.state.studentArr && this.state.studentArr.length
                  ? this.state.studentArr
                  : [],
              )
            }
          >
            Download All Reports
          </Button>
        </ButtonGroup>
        {this.getClasses(this.props.classes, this.state.selectedClass, true)}
      </ButtonToolbar>
    );
  };

  render() {
    const { totalStudent, studentHeader, studentList } = this.props;
    const { inOffset } = studentHeader;
    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      hideSelectColumn: false,
      onSelect: (row, isSelected, e) => this.onRowSelect(row, isSelected, e),
      customComponent: this.customMultiSelect,
      onSelectAll: this.handleSelectAll,
    };

    return (
      <RootLayout props={this.props}>
        <div
          style={{
            display: "flex",
            padding: "2em",
            flexDirection: "column",
            gap: "2rem",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {this.props.currentProgram.id ? (
              <RenderYearTab
                program={this.props.currentProgram}
                history={this.props.history}
                changeTab={this.changeTab}
              />
            ) : (
              <div />
            )}
            <div>
              <div
                ref={this.dropdownRef}
                className="custom-dropdown"
                style={{ position: "relative" }}
              >
                <button
                  className="btn downloadReport"
                  type="button"
                  onClick={() =>
                    this.setState({ dropdownOpen: !this.state.dropdownOpen })
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    flexDirection: "row",
                    marginTop: "0px",
                  }}
                >
                  <p className="allonetxt" style={{ margin: 0 }}>
                    DOWNLOAD REPORT
                  </p>
                  <img
                    className="downarrowstudent"
                    src={downarrow}
                    alt="Dropdown arrow"
                    style={{
                      cursor: "pointer",
                      transform: this.state.dropdownOpen
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                      transition: "0.3s",
                    }}
                  />
                </button>

                {this.state.dropdownOpen && (
                  <ul className="custom-dropdown-menu">
                    {/* <li>
                      <button
                        className="Download_All_Reports my-2"
                        onClick={() =>
                          this.handleDownloadReport(
                            this.state.studentArr &&
                              this.state.studentArr.length
                              ? this.state.studentArr
                              : [],
                          )
                        }
                      >
                        Download All Reports
                      </button>
                    </li> */}
                    <hr style={{ margin: "0 0 3px 0" }} />
                    <li>
                      <button
                        className="Download_All_Reports"
                        onClick={() =>
                          this.handleCBSEDownloadReport(
                            this.state.studentArr &&
                              this.state.studentArr.length
                              ? this.state.studentArr
                              : [],
                          )
                        }
                      >
                        Download CBSE Reports
                      </button>
                    </li>
                    <hr style={{ margin: "0 0 3px 0" }} />
                    <li>
                      <button
                        className="Download_All_Reports"
                        onClick={() => this.viewReport()}
                      >
                        View CBSE Reports
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>

          <div
            className="borderRadius"
            style={{
              display: "flex",
              backgroundColor: "white",
              paddingBottom: "2rem",
            }}
          >
            <div
              className="hsg-toolbar-group"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {this.confirmationModal()}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "2rem 0rem",
                }}
              >
                {this.tab()}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  {this.getToolbarItems()}
                </div>
              </div>

              <div className="padding-left-1rem padding-right-1rem">
                {this.props.currentProgram &&
                  this.props.currentProgram.billing &&
                  this.props.currentProgram.billing.id && (
                    <HSGStudentGrid
                      className="hsg-report-table"
                      offset={inOffset}
                      data={studentList}
                      downloadStudentReport={(studentId) =>
                        this.downloadStudentReport(studentId)
                      }
                      onSelect={(row, isSelected, e) =>
                        this.onRowSelect(row, isSelected, e)
                      }
                      onSelectAll={this.handleSelectAll}
                      setSelectedStudent={this.props.setSelectedStudent}
                      startNodeId={
                        this.props.startNodeMap[
                          this.props.currentProgram.billing.id
                        ].id
                      }
                      total={totalStudent}
                      search={(param) => this.searchStudent(param)}
                      selectRowProp={selectRowProp}
                      showNext={this.showNext}
                      inSearchString={this.state.inSearchString}
                      setSearchString={(e) =>
                        this.setState({ inSearchString: e })
                      }
                      getAssessmentFilters={this.getAssessmentFilters}
                      selectedBillingId={
                        this.props?.currentProgram?.billing?.id
                      }
                      show={true}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </RootLayout>
    );
  }
}

export default Student;
